module.exports = __webpack_public_path__ + "static/media/gruyere_rolls.02f0072a.JPG";